const _allSwaggerModule = [
  'core',
  'user',
  'todo',
  'items',
  'labels',
  'EventDetails',
  'targetterContent',
  'getMarketingLandingPage',
  'eventManagement',
  'getStateList',
  'getStoreList',
  'eventCategory',
  'GiftRegistryNewAddress',
  'contractPage',
  'giftRegistryAddress',
  'searchResult',
  'getEventDetails',
  'giftPreferences',
  'deliveryAddress',
  'eCardDetails',
  'SearchedPoductData',
  'megaMenuData',
  'cartCountData',
  'multipleEvent',
  'createAccount',
  'createEventObject',
  'accountSummary',
  'logout',
  'footer',
  'getOpeningOrClosingGiftForEvent',
  'setOpeningOrClosingGiftForEvent',
  'closureGiftPriceRange',
  'giftListGuestView',
  'storeLocation',
  'Kaltura',
  'yahoo',
  'cachecontrols',
];
const allSwaggerModule = _allSwaggerModule.map((item) => item);

const commonConfig = {
  scheduler: {
    enable: false,
  },
  swagger: {
    info: {
      title: 'Liverpool GR - API Documentation',
    },
    grouping: 'tags',
  },
  viewEngine: {
    type: 'nunjucks',
  },
  logger: {
    level: 'info', // silly
    colorize: true,
    timestamp: () => {
      const date = new Date();
      return `${date.toLocaleString('es-MX')}`;
    },
  },
  exportToClient: {
    // export to browser  TODO: Need to work on same
    gacode: 'UA-000000000-1',
    mockObject: {
      test: 1,
    },
  },
};

module.exports = {
  development: {
    version: '0.0.1',
    connection: {
      port: 3000,
      routes: {
        payload: {
          maxBytes: 1024 * 1024 * 100,
        },
      },
      state: {
        // If your cookie format is not RFC 6265, set this param to false.
        strictHeader: false,
      },
    },
    ...commonConfig,
  },
  sit1: {
    version: '0.0.1',
    connection: {
      port: 8080,
      routes: {
        payload: {
          maxBytes: 1024 * 1024 * 100,
        },
      },
      state: {
        // If your cookie format is not RFC 6265, set this param to false.
        strictHeader: false,
      },
    },
    ...commonConfig,
  },
  qa1: {
    version: '0.0.1',
    connection: {
      port: 8080,
      routes: {
        payload: {
          maxBytes: 1024 * 1024 * 100,
        },
      },
      state: {
        // If your cookie format is not RFC 6265, set this param to false.
        strictHeader: false,
      },
    },
    ...commonConfig,
  },
  production: {
    version: '0.0.1',
    connection: {
      port: 8080,
      routes: {
        payload: {
          maxBytes: 1024 * 1024 * 100,
        },
      },
      state: {
        // If your cookie format is not RFC 6265, set this param to false.
        strictHeader: false,
      },
    },
    ...commonConfig,
  },
};
